import {
  getToken,
  setToken,
  removeToken,
  setTicket,
  getTicket,
  removeTicket,
  setIdentity,
  getIdentity,
  removeIdentity
 
} from "@/utils/auth";
import {
  getJwtToken,
  getUserInfo,
  getPublicKey
} from "@/api/sign";
import {
  getUserNav
  // getUserDesktop,
  // getUserButtonPermission
} from "@/api/user";
import request from "@/utils/request";

const state = {
  userIdentity: "Tourist",
  token: getToken(),
  ticket: getTicket(),
  avatar: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
  userInfo: {},
  userNav: [{
      CODE: "Home",
      NAME: "首页"
    },
    {
      CODE: "ServiceCenter",
      NAME: "服务中心"
    },
    {
      CODE: "NewsCenter",
      NAME: "资讯中心"
    },
    {
      CODE: "MessageCenter",
      NAME: "消息中心"
    }
  ],
  userDesktop: [],
  userButtons: [],
  userDefaultNav: {
    Tourist: [{
        CODE: "Home",
        NAME: "首页"
      },
      {
        CODE: "ServiceCenter",
        NAME: "服务中心"
      },
      {
        CODE: "NewsCenter",
        NAME: "资讯中心"
      },
      {
        CODE: "MessageCenter",
        NAME: "消息中心"
      }
    ],
    Visitor: [{
        CODE: "Home",
        NAME: "首页"
      },
      {
        CODE: "ServiceCenter",
        NAME: "服务中心"
      },
      {
        CODE: "EventsCenter",
        NAME: "事务中心"
      },
      {
        CODE: "NewsCenter",
        NAME: "资讯中心"
      },
      {
        CODE: "MessageCenter",
        NAME: "消息中心"
      }
    ],
    Student: [{
        CODE: "Home",
        NAME: "首页"
      },
      {
        CODE: "ServiceCenter",
        NAME: "服务中心"
      },
      {
        CODE: "EventsCenter",
        NAME: "事务中心"
      },
      {
        CODE: "NewsCenter",
        NAME: "资讯中心"
      },
      {
        CODE: "ScheduleCenter",
        NAME: "日程中心"
      },
      {
        CODE: "MessageCenter",
        NAME: "消息中心"
      }
    ],
    Teacher: [{
        CODE: "Home",
        NAME: "首页"
      },
      {
        CODE: "ServiceCenter",
        NAME: "服务中心"
      },
      {
        CODE: "EventsCenter",
        NAME: "事务中心"
      },
      {
        CODE: "NewsCenter",
        NAME: "资讯中心"
      },
      {
        CODE: "ScheduleCenter",
        NAME: "日程中心"
      },
      {
        CODE: "BusinessManagementCenter",
        NAME: "业务管理中心"
      },
      {
        CODE: "MessageCenter",
        NAME: "消息中心"
      }
    ]
  },
  userGolbalSearch: "",
  serveUrl: "http://superportal.dice.supwisdom.com/",
  flowServeUrl: "http://formflow-ttc.dice.supwisdom.com/",
  request: request
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
    setToken(token);
  },
  SET_TICKET: (state, ticket) => {
    state.ticket = ticket;
    setTicket(ticket);
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;

  },
  SET_PUBLICKEY:(state,publicKey)=>{
    state.publicKey=publicKey
  },
  SET_USER_IDENTITY: (state, userIdentity) => {
    state.userIdentity = userIdentity;
    setIdentity(userIdentity);
  },
  SET_USER_NAV: (state, userNav) => {
    state.userNav = userNav;
  },
  SET_DEFAULT_USER_NAV: state => {
    switch (state.userIdentity) {
      case "Tourist":
        state.userNav = state.userDefaultNav.Tourist;
        break;
      case "Visitor":
        state.userNav = state.userDefaultNav.Visitor;
        break;
      case "Student":
        state.userNav = state.userDefaultNav.Student;
        break;
      case "Teacher":
        state.userNav = state.userDefaultNav.Teacher;
        break;
      default:
        state.userNav = state.userDefaultNav.Tourist;
        break;
    }
  },
  SET_UNIAITH_NONCE: (state, nonce) => {
    state.uniAuthNonce = nonce;
  },
  SET_USER_DESKTOP: (state, userDesktop) => {
    state.userDesktop = userDesktop;
  },
  SET_USER_BUTTON: (state, buttons) => {
    state.userButtons = buttons;
  },
  GET_TOKEN: state => {
    state.token = getToken();
  },
  SET_USER_GOLBALSEARCH: (state, value) => {
    state.userGolbalSearch = value;
  }
};

const actions = {
  // 获取用户信息
  getInfo({
    commit
  }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", getToken());
      commit("SET_TICKET", getTicket());
      commit("SET_USER_IDENTITY", getIdentity());
      // Jwt Token
      // getJwtToken().then(res => {
      //   window.sessionStorage.JwtToken = res.data.data.idToken;
      // });
      // 用户信息
      // getUserInfo().then(res => {
      //   commit("SET_USER_INFO", res.data.data);
      // });
      // 用户导航
      // getUserNav()
      //   .then(res => {
      //     commit("SET_DEFAULT_USER_NAV");
      //   })
      //   .catch(res => {
      //     commit("SET_DEFAULT_USER_NAV");
      //   });
      commit("SET_DEFAULT_USER_NAV");
      getUserInfo().then(res => {
        commit("SET_USER_INFO", res.data.data);
      });
      getPublicKey().the(res=>{
        commit("", res.data.data);
      })
      // 用户桌面
      // getUserDesktop().then(res => {
      //   commit("SET_USER_DESKTOP", res.data.data.items);
      // });
      // 用户权限
      // getUserButtonPermission().then(res => {
      //   commit("SET_USER_BUTTON", res.data.data.items);
      // });
      resolve();
    });
  },

  // 登出
  signOut({
    commit
  }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      commit("SET_USER_INFO", []);
      removeToken();
      removeTicket();
      removeIdentity();
      window.sessionStorage.clear();
      // window.location.href = `http://portal.dice.supwisdom.com/portal-web/oauth/logout?returnUrl="${process.env.VUE_APP_URL}"`;
      resolve();
    });
  },

  // 重新登录
  resetToken({
    commit
  }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      removeToken();
      resolve();
    });
  }
};

export default {
  state,
  mutations,
  actions
};